import React, { useEffect, useRef, useState } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'
import { usePersonalStore } from '../../../stores/personalInfo'
import Toast from 'react-native-toast-message'


const AlinformationForm = ({ navigation, route }: any): JSX.Element => {
  const formikRef = useRef(null)
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey
  } = params



  const [selected1, setSelected1] = useState(false)
  const [selected2, setSelected2] = useState(false)



  const options2 = [
    { key: 1, value: 'Single' },
    { key: 2, value: 'Married Filing Separately' },
    // { key: 3, value: 'None' }
  ]

  const options1 = [
    { key: 1, value: 'Married ' },
    { key: 2, value: 'Single Head of Family' }
  ]

  const intialValues = {
    Claimnopersonalexemption: '',
    FilingSeparately: '',
    ClaimingHeadofFamily: '',
    dependents: null,
    Additionalamount: '',

  }

  const { loading, postalonline, } = useFormsStore()


  const alschema = yup.object().shape({

    Claimnopersonalexemption: yup
      .string()
      .matches(/^(0|1)$/i, "Enter '0' or '1'")
      .required(" Personal exemption is a required field"),

    FilingSeparately: yup.mixed().nullable(),

    ClaimingHeadofFamily: yup.mixed().nullable(),

    dependents: yup.string()
      .nullable()
      .test(
        "require-dependents",
        "No of dependents is a required field",
        function (value) {
          const { Claimnopersonalexemption } = this.parent;
          if (Claimnopersonalexemption == '1') {
            return !!value;
          }
          return true;
        }
      ),



    Additionalamount: yup.string().nullable()
  }).test(
    "at-least-one-required",
    "Either Filing Separately or Claiming Head of Family is required when Claimnopersonalexemption is empty",
    function (values) {


      const { Claimnopersonalexemption, FilingSeparately, ClaimingHeadofFamily } = values;
      if (Claimnopersonalexemption == "1") {
        if (!FilingSeparately && !ClaimingHeadofFamily) {
          return this.createError({
            path: "FilingSeparately",
            message: "Either Filing Separately or Claiming Head of Family is required",
          });
        }

      }

      return true;
    }
  );




  const initializestore = useInitializeStore()
  const personalstore = usePersonalStore()


  let toatalexemptions
  const calTotal = (values) => {
    if (values.Claimnopersonalexemption == '0') {
      toatalexemptions = `${values.FilingSeparately}${(values.dependents ? values.dependents : 0)}`
    }
    else {
      if (values.FilingSeparately == 3) {
        toatalexemptions = `${values.ClaimingHeadofFamily}${(values.dependents ? values.dependents : 0)}`
      }
      else if (values.ClaimingHeadofFamily) {
        toatalexemptions = `${values.ClaimingHeadofFamily}${(values.dependents ? values.dependents : 0)}`
      }
      else {
        toatalexemptions = `${values.FilingSeparately}${(values.dependents ? values.dependents : 0)}`
      }

    }

  }


  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'AL Withholding Taxation '}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={alschema}
          onSubmit={async (values, actions) => {
            calTotal(values)
            const data = {
              completeOnline: mode === 'upload' ? false : true,
              essuserKey: initializestore.initializeData.userkey,
              entityId: personalstore.personalData?.entityId,
              claimPersonalExemption: values.Claimnopersonalexemption == '' || Number(values?.Claimnopersonalexemption) == 1 ? null : values.Claimnopersonalexemption,
              filingSeparately: values.FilingSeparately,
              claimingHeadofFamily: values.ClaimingHeadofFamily,
              dependents: values.dependents,
              additionalamount: values.Additionalamount ? values.Additionalamount : null,
              totalExemptions: toatalexemptions,
              formKey: essUserOnBoardingFormKey,
              essObKey: essUserOnBoardingKey
            }

            console.log("data", data)

            const response = await postalonline(data)
            if (response?.success) {
              if (mode === 'online') {
                navigation.navigate('Alonline', {
                  userId,
                  mode,
                  essUserOnBoardingKey,
                  essUserOnBoardingFormKey,
                  values,
                  toatalexemptions
                })
              } else {
                await Toast.show({
                  type: 'success',
                  position: 'bottom',
                  text1: response?.message,
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60,
                  onHide: () => {
                    navigation.replace('OnboardingForms')
                  }
                })
              }
            } else {
              await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
              })
            }
          }}
        >
          {(props) => (
            <>
              <Card>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '65%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {`If you claim no personal exemption for yourself and wish to withhold at the highest rate,Enter 0 or else Enter 1 *`}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.Claimnopersonalexemption}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        props.handleChange('Claimnopersonalexemption')(text)
                        props.setFieldValue('dependents', null)
                        if (text === '0') {
                          props.setFieldValue('FilingSeparately', 'S')
                          props.setFieldValue('ClaimingHeadofFamily', '')
                          setSelected1(false)
                          setSelected2(false)
                        } else {
                          props.setFieldValue('FilingSeparately', '')
                          props.setFieldValue('ClaimingHeadofFamily', '')
                          setSelected1(false)
                          setSelected2(false)
                        }
                      }}
                    />
                    {props.touched.Claimnopersonalexemption &&
                      props.errors.Claimnopersonalexemption && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.Claimnopersonalexemption as string}
                        </Text>
                      )}
                  </View>
                </View>
                {props.values.Claimnopersonalexemption == '1' && selected2 == false && (
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'center', width: '50%' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        Single or Married Filing Separately, a $1500 exemption
                        is allowed
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <SelectKeyValue
                        title="Single or Married Filing Separately, a $1500 exemption is allowed*"
                        options={options2}
                        selectedOption={
                          props.values.FilingSeparately === 'S'
                            ? 'Single'
                            : props.values.FilingSeparately === 'MS'
                            ? 'Married Filing Separately'
                            : ''
                        }
                        onSelect={(option: string) => {
                          // props.setFieldValue('dependents', null)
                          // props.setFieldValue('Additionalamount', '')
                          setSelected1(true)
                          setSelected2(false)
                          props.setFieldValue('ClaimingHeadofFamily', '')
                          if (option == '1') {
                            props.setFieldValue('FilingSeparately', 'S')
                          } else if (option == '2') {
                            props.setFieldValue('FilingSeparately', 'MS')
                          } else {
                            props.setFieldValue('FilingSeparately', '')
                          }


                        }}
                        textColor="primary"
                      />
                      {props.touched.FilingSeparately &&
                        props.errors.FilingSeparately && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.FilingSeparately as string}
                          </Text>
                        )}
                    </View>
                  </View>
                )}
                {props.values.Claimnopersonalexemption == '1' && selected1 == false && (
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'center', width: '50%' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        Married or Single Claiming Head of Family, a $3000
                        exemption is allowed
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <SelectKeyValue
                        title="Married or Single Claiming Head of Family, a $3000 exemption is allowed"
                        options={options1}
                        selectedOption={
                          props.values.ClaimingHeadofFamily === 'M'
                            ? 'Married '
                            : props.values.ClaimingHeadofFamily === 'H'
                            ? 'Single Head of Family'
                            : ''
                        }
                        onSelect={(option: string) => {
                          setSelected2(true)
                          setSelected1(false)
                          props.setFieldValue('FilingSeparately', '')
                          if (option == '1') {
                            props.setFieldValue('ClaimingHeadofFamily', 'M')
                          }
                          else {
                            props.setFieldValue('ClaimingHeadofFamily', 'H')
                          }

                        }}
                        textColor="primary"
                      />
                      {props.touched.ClaimingHeadofFamily &&
                        props.errors.ClaimingHeadofFamily && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.ClaimingHeadofFamily as string}
                          </Text>
                        )}
                    </View>
                  </View>
                )}


                {(props.values.Claimnopersonalexemption == "1") && (selected1 || selected2) && (
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {'Number of Dependents *'}
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.dependents}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('dependents')(text)
                          }
                        }}
                      />
                      {props.touched.dependents && props.errors.dependents && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.dependents as any}
                        </Text>
                      )}
                    </View>
                  </View>
                )}

                {/* {props.values.Claimnopersonalexemption == '0' && ( */}
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {
                        'Additional amount, if any, you want deducted each pay period.'
                      }
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.Additionalamount}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('Additionalamount')(text)
                        }
                      }}
                    />
                    {props.touched.Additionalamount &&
                      props.errors.Additionalamount && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.Additionalamount}
                        </Text>
                      )}
                  </View>
                </View>
                {/* )} */}

                {loading ? (
                  <ActivityIndicator />
                ) : (
                  <View style={{ margin: 10 }}>
                    <CustomButton
                      text={mode === 'upload' ? 'Submit Information' : 'Next'}
                      onPress={props.handleSubmit}
                    />
                  </View>
                )}
              </Card>
            </>
          )}
        </Formik>
      </View>
    </KeyboardAwareScrollView>
  )
}
export default AlinformationForm


